import { Typography } from '@mui/material'
import { ButtonMui } from 'src/components/ButtonMui'
import styled from 'styled-components'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0.4rem 0 0.4rem 0;
  max-width: 100%;
`

export const BoxHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 0 1rem 0 1rem;
`

export const CustomButton = styled(ButtonMui)`
  width: 12rem;
`

export const NavigateInfo = styled(Typography)`
  margin-top: 3rem !important;
  margin-bottom: -4rem !important;
`

export const DoneInfo = styled(Typography)`
  height: 660px;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const BoxNavigation = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding: 0;
  gap: 2rem;
  margin-top: -4rem;
`
